import { motion } from "framer-motion";

export const Specs = ({ t }) => (
  <section className="border-y border-white/10 bg-[#040918]" data-testid="specs-section">
    <div className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 md:py-20">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="mb-10 font-mono-spec text-[11px] uppercase tracking-[0.3em] text-[#00e5ff]"
        data-testid="specs-kicker"
      >
        / {t.kicker}
      </motion.p>
      <div className="grid grid-cols-2 gap-px overflow-hidden rounded border border-white/10 bg-white/10 sm:grid-cols-3 lg:grid-cols-5">
        {t.items.map(([label, value], i) => (
          <motion.div
            key={label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.04 }}
            className="group bg-[#040918] p-5 transition-colors duration-500 hover:bg-[#081226] md:p-6"
            data-testid={`spec-${i}`}
          >
            <p className="font-mono-spec text-[9px] uppercase tracking-[0.3em] text-slate-500 transition-colors duration-500 group-hover:text-[#00e5ff]">
              {label}
            </p>
            <p className="mt-3 font-mono-spec text-lg font-medium text-slate-100 md:text-xl">{value}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
